import React, {Component} from 'react';
import {translate} from 'react-i18next';
import WaitingModal from '../../generics/WaitingModal';
import moment from 'moment';
import swal from 'sweetalert';
import { Table, Button, FormGroup } from 'react-bootstrap';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import Inputmask from 'inputmask';
import RaisedButton from 'material-ui/RaisedButton';
import Notifications, {notify} from 'react-notify-toast';

import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import {Typeahead} from 'react-bootstrap-typeahead';
import ModalCenter from '../../generics/modalCenter';

var Config = require('../../../config');

class ShippingsNew extends Component{
	constructor(props){
		super(props);

		this.validateInput = this.validateInput.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSave = this.onSave.bind(this);
		
		this.addComponent = this.addComponent.bind(this);
		this.removeUnitFromList = this.removeUnitFromList.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.selectComponent = this.selectComponent.bind(this);
		this.addCenter = this.addCenter.bind(this);
		this.getNationalCenters = this.getNationalCenters.bind(this);

		this.state = {
			date_form : "",
			hour: "",
			health_facilities:[],
			requested_by:"",
			requested_to:"",
			messenger:"",
			user:"",
			user_id:"",
			observations:"",
			priorities:[{id:"0",name:"URGENTE"},{id:"0",name:"24 HORAS"}],
			priority:"URGENTE",
			component_list:[],
			unit_number:"",
			component:{},
			status:"",

			requestedSelected:[],
			indice:-1,

			requested2Selected:[],
			indice2:-1,

			bloodComponents:[],
			groupRH:[],

			blood_component:"",
			amount:"",
			group_rh:"",

			unitsAdded:[],
			unitsSolicited:[],

			isLoading: false,
			req_by:"",
			req_to:"",
			national_centers:[],
			responsable:"",
			dis_unit_cad:{},
			character_observa:'500',
			save:false,
			user_add_center:""
		}
	}//18001215

	componentDidMount(){
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=USER_ADD_CENTER&x=', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					user_add_center: response.value
				});
			}
		});

		this.getHealthFacilities();

		

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=DIS_UNIT_CAD&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				dis_unit_cad: response
			});
		})

		this.setState({
			requested_by:sessionStorage.getItem("health_facilities_id"),
		});



		//fecha y hora
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);
			var aux_date = new Date();

			this.setState({
				date_form : aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
				hour:hours,
			});
		});		

		

		var selector = document.getElementById("hour");
		var im = new Inputmask("--:--");
		im.mask(selector);

		//obtener usuario
		var user = JSON.parse(sessionStorage.getItem('medical_staff'));

		var name = ""
		if (user.names) {name += user.names};
		if (user.lastname1) {name += ' '+user.lastname1};
		if (user.lastname2) {name += ' '+user.lastname2};

		this.setState({
			user :  name,
			user_id:user.id,
		});		

		//componentes sanguineos
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=true',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      bloodComponents: response
		    });
		})

		//grupo y rh
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_group_rh',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      groupRH: response
		    });
		})
	}

	addCenter(){
		this.modal_add_center.handleShow();	
	}

	getEditionItems(){
		fetch(Config.default.apiGateway.URL+'unit_export/'+this.props.match.params.id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		}).then(res => {
			this.props.waiting.handleClose();
	    	if(res.ok){
	          	return res.json();
	        }else{
	          	res.text().then(function(result) {
	            	swal('¡Error', result, 'error');
	          	});
        	}
        	
        }).then(response => {
			if(response !== undefined){
				var date = new Date(response.date);
				 //obtener usuario
				var user = JSON.parse(sessionStorage.getItem('medical_staff'));

				var name = ""
				if (user.names) {name += user.names};
				if (user.lastname1) {name += ' '+user.lastname1};
				if (user.lastname2) {name += ' '+user.lastname2};

				

				this.setState({
					user :  name,
					requested_by:response.shipper_center_id,
					requested_to:response.acceptor_center_id,
			      	messenger: response.mensajero,
			      	observations: response.observaciones,
			      	hour: moment(response.hour, 'HH:mm:ss').format('HH:mm'),
			      	date_form : date.getFullYear()+'-'+("0" + (date.getMonth() + 1)).slice(-2)+'-'+("0" + date.getDate()).slice(-2),
			      	priority: response.priority,
			      	unitsSolicited:response.units,
			      	show: true,
					title: "Ver detalles del Envío",
					//responsable:response.unit_export.person_acceptor_center,
			    });

			    var index = this.state.national_centers.findIndex(obj => 
			    	obj.id === parseInt(response.shipper_center_id)
			    
			    )
			    var index1 = this.state.national_centers.findIndex(obj => 
			    	obj.id === parseInt(response.acceptor_center_id)
			    )

			    if(index !== -1){
			    	this.setState({
						indice:index,
				      	requestedSelected: [this.state.national_centers[index]],
				    });
			    }

			    if(index1 !== -1){
			    	this.setState({
				      	indice2:index1,
				      	requested2Selected: [this.state.national_centers[index1]],
				    });
			    }
			    

			    response.units.map((u)=>(
			    	
					this.setState({ 
						unitsAdded: [...this.state.unitsAdded, {
							unit_id:u.unit.id,
							component_id:u.unit.blood_component_id,
							donation:u.unit.unit_number,
							component:u.blood_component_name,
							component_type:"",
							group:u.unit.group,
							rh:u.unit.rh,
							volume:u.unit.volume,
							component_number:u.component_number
						}],
					})
			    ))
			    //this.getHealthFacilities();

			   
			}

		})
	}

	//get healt facilities
	getHealthFacilities(){
		//traer hospitales
		fetch(Config.default.apiGateway.URL+'health_facilities',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      health_facilities: response
		    });
			
			for (var i = 0; i < response.length; i++) {
				if (response[i].id == this.state.requested_by) {
					
					this.setState({
						indice:i,
				      	requestedSelected: [response[i]],
				    });
				};

			};
			this.getNationalCenters()	
		})
	} 

	getNationalCenters(){
		fetch(Config.default.apiGateway.URL+'national_centers?option=distribution&health_facility='+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			var temp = [];
			for (var i = 0; i < response.length; i++) {
				response[i].national_center.name = response[i].national_center.name +' - '+response[i].address.estado;
				temp.push(response[i].national_center)
			};

			this.setState({national_centers: temp});

			setTimeout(()=>{
				if(this.props.match.params.id !== undefined){
					this.getEditionItems();
				}
			}, 500)
		})
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		var campo = e.target.name;

		if(e.target.value.length <= 500 && e.target.name === 'observations'){
			var total = 500 - e.target.value.length;
			if(e.target.value.length <= 500){
				this.setState({character_observa:total});
			}
			this.setState({
				[campo] : e.target.value
			});
		}else if(e.target.name === 'responsable'){
			if(e.target.value.length <= 120){
				this.setState({[campo] : e.target.value});
			}
		}else if(e.target.name !== 'observations'){
			this.setState({
				[campo] : e.target.value
			});
		}
		

		if(campo === 'hour'){
			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		}else{
			setTimeout(function(){
				this.showCtrlError(campo);
			}.bind(this), 500)
		}	
	}

	selectComponent(e, name){
		if(e.key === 'Enter'){
			this.handleTypeAheadChange(name, e)
		}
	}

	handleTypeAheadChange = name => values => {

        if(values.length > 0){
        	if(name === 'component'){
        		if(values[0].status !== 'BLOQUEADA'){
        			this.setState({
			            [name]: values[0]
			        });

			        setTimeout(()=>{
			        	this.addComponent();
			        }, 500);
        		}else{
        			swal('Error', 'El componente que intenta seleccionar se encuentra bloqueado', 'error');
					this._typeahead_component.getInstance().blur();
					this._typeahead_component.getInstance().clear();
					this._typeahead_component.getInstance().focus();
        		}
	        		
        	}else{
        		this.setState({
		            [name]: values[0].id
		        });

		        if (name === 'requested_by') {
		        	this.setState({
						indice:0,
						requestedSelected:values,
				    });
		        };

		        if (name === 'requested_to') {
		        	this.setState({
						indice2:0,
						requested2Selected:values,
				    });

				    document.getElementById('date_form').focus();
		        };
        	}
        	
        }
    }

    _handleSearch = (query) => {
	    this.setState({
			indice:-1,
			requestedSelected:[],
	    });
	}

	_handleSearch2 = (query) => {
	    this.setState({
			indice2:-1,
			requested2Selected:[],
	    });
	}

	searchComponent(e){
		if(e.key === 'Enter'){
			e.preventDefault();

			fetch(Config.default.apiGateway.URL+'units/send_unit?health_facilities_id='+sessionStorage.getItem('health_facilities_id')+'&unit_number='+e.target.value, {
				method: 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return res.json();
				}else{
					res.text().then(msg=>{
						swal("Error", msg, 'error')
					});

					document.getElementById('unit_number').focus();
				}
			})
			.then(response=>{
				if(response !== undefined){
					this.setState({
						component_list: response
					})
					this._typeahead_component.getInstance().clear();
					this._typeahead_component.getInstance().focus();
				}
			})
		}
	}

	addComponent(){
		var repeated = false;
		var validComponent = false;

		if (this.state.unit_number !== "" && this.state.component.length !== 0 ) {
			var index = this.state.unitsSolicited.findIndex(obj => obj.component_type === this.state.component.blood_component.component_type);
			
			if(index === -1){
				validComponent = true;
			}

			for (var i = 0; i < this.state.unitsAdded.length; i++) {
				if(this.state.unitsAdded[i].unit_id === this.state.component.unit.id &&
					this.state.unitsAdded[i].component_id === this.state.component.blood_component.id){
					repeated = true;
				}
			};

			if(this.state.component.status === 'DISPONIBLE' || this.state.dis_unit_cad.value === 'YES'){
				if (repeated === true) {
					swal('¡La unidad no se puede agregar!', '¡Ya se ingreso esa unidad!', 'error');
				}else {
					var obj = {}
					obj.unit_id = this.state.component.unit.id;
					obj.component_id = this.state.component.blood_component.id;
					obj.donation = this.state.component.donation_number !== "" ?
									this.state.component.donation_number
								: this.state.component.unit.unit_number;
					obj.component = this.state.component.blood_component.component;
					obj.component_type = this.state.component.blood_component.component_type;
					obj.group = this.state.component.unit.group;
					obj.rh = this.state.component.unit.rh;
					obj.volume = this.state.component.unit.volume;
					obj.component_number = this.state.component.unit.component_number;
					
					this.setState({ 
						unitsAdded: [...this.state.unitsAdded, obj],
						unit_number:"",
						component:{},
						component_list:[],
					});

					this._typeahead_component.getInstance().clear();
					document.getElementById('unit_number').classList.remove('error');
					document.getElementById('unit_number').focus();

				};	
			}else{
				if(this.state.component.status === 'RESERVADA'){
					swal({
						title: '¿Desea retirar la reserva?',
						text: 'No es posible agregar el componente debido a que su estatus es :'+this.state.component.status,
						type: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#DD6B55',
						confirmButtonText: '¡Si, Retirar reserva!',
						cancelButtonText: '¡No, Cancelar!',
						closeOnConfirm: true,
						closeOnCancel: true
					}, (isConfirm)=> {
						if (isConfirm) {
							fetch(Config.default.apiGateway.URL+'unit_reserved/by_unit/'+this.state.component.unit.id,{
								method:'delete',
								headers: new Headers({
									'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
									'Accept'		: 'application/json',
									'Content-Type'	: 'application/json'
								})
							}).then(res => {
								if(res.ok){
									return res.json();
								}else{
									res.text().then((msg)=>{
										swal('Error', msg, 'error');
									});
								}
							}).then(response => {
								var obj = {}
								obj.unit_id = this.state.component.unit.id;
								obj.component_id = this.state.component.blood_component.id;
								obj.donation = this.state.component.donation_number !== "" ?
												this.state.component.donation_number
											: this.state.component.unit.unit_number;
								obj.component = this.state.component.blood_component.component;
								obj.component_type = this.state.component.blood_component.component_type;
								obj.group = this.state.component.unit.group;
								obj.rh = this.state.component.unit.rh;
								obj.volume = this.state.component.unit.volume;
								obj.component_number = this.state.component.unit.component_number;
								
								this.setState({ 
									unitsAdded: [...this.state.unitsAdded, obj],
									unit_number:"",
									component:{},
									component_list:[],
								});

								this._typeahead_component.getInstance().clear();
								document.getElementById('unit_number').classList.remove('error');
								document.getElementById('unit_number').focus();
							});
						}
					});
				}else{
					swal('Error', 'No es posible agregar el componente debido a que su estatus es :'+this.state.component.status, 'error');
				}
				
				
			}

				
		} /*else{
			swal('¡El registro no se puede agregar!', '¡Ingrese unidad y componente !', 'error');
		};	*/
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);
      		if(form.elements[index + 1] !== undefined){
      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null){
    					form.elements[index + 1].focus();
    				}else if(form.elements[index + 1].getAttribute("disabled") === ""){
    					form.elements[index + 2].focus();
    				}
    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	isValidSearch(){
	    let isFormValid = true;
	    const unit_number = document.getElementById('unit_number');

    	const isInputValid2 = this.showCtrlError(unit_number.name);
      	if (!isInputValid2) {
        	isFormValid = false;
    	}

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	removeUnitFromList = (indice) => {
		var array = [...this.state.unitsAdded];
		array.splice(indice, 1);
		this.setState({unitsAdded: array});	
	}

	print(id){
		fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+
     		sessionStorage.getItem("health_facilities_id")+
     		'&file_type=AREA_SEND_UNIT&extraction_type=',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	          'Content-Type': 'application/json',
	        })
      	}).then(res => {
            if(res.ok){
                return res.json();
            }else{
                res.text().then(function(result) {
                  swal('¡Error', result, 'error');
                });
            }
        }).then(async response => {
        	if(response.res === 0){
          		swal('Atención!', "No se ha definido ningún formato de impresión", 'warning');
        	}else{
          		this.props.waiting.handleShow('Imprimiendo...');
          
		        var obj ={};
		        obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		        obj.id = id;
		        obj.file_type = "area_send_unit";
		        obj.nEtiqueta = [0];

		        var type = await this.props.getDocumentType(obj.file_type);

				var document;
				if(type.print_type === 'template'){
					document = await this.props.printDocumentTemplate(obj, type.print_automatically);
				}else if(type.print_type === 'external'){
					document = await this.props.printDocumentExternal(obj, type.print_automatically);
				}

				if(document !== undefined){
					this.props.waiting.handleClose();
					this.setState({ show: false});
				}else{
					this.props.waiting.handleClose();
				}
          		
        	}
      	})
	}

	onSave(){
		//this.waiting_modal.handleShow('Guardando...');
		if(this.isValidDate(this.state.date_form)){
			if(this.isValidForm()){
				
				var object = {};
				object.shipper_center_id = parseInt(this.state.requested_by);
				object.acceptor_center_id = parseInt(this.state.requested_to);
				
				object.mensajero = this.state.messenger;
				object.observaciones = this.state.observations;
				object.priority = this.state.priority;
				//object.user_request_by = this.state.user_id;
				object.person_acceptor_center = this.state.responsable;

				var date = moment(this.state.date_form.split('-').reverse().join('/'), 'DD-MM-YYYY');
				var hour = moment(this.state.hour, 'h:mm a');

				object.date = date.format('MM-DD-YYYY');;
				object.hour = this.state.hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm');

				var temp = [];

				for (var i = 0; i < this.state.unitsAdded.length; i++) {
					temp.push({unit_id:this.state.unitsAdded[i].unit_id});
				};


				object.unit_export_asociation = temp;

				var apiUrl = this.props.match.params.id !== undefined ? 'unit_export/partial_delete' : 'unit_export';

				if(this.props.match.params.id !== undefined){
					object.id = this.props.match.params.id;
				}
				
				if(temp.length > 0){
					this.setState({save:true});
					fetch(Config.default.apiGateway.URL+apiUrl,{
						method:'post',
						body: JSON.stringify(object),
						headers: new Headers({
							'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
							'Accept'		: 'application/json',
							'Content-Type'	: 'application/json'
						})
					}).then(res =>{
						//this.waiting_modal.handleClose();

						if(res.ok){
							return res.json();
						}else{
							this.setState({save:false});
							res.text().then(function(result){
								swal("Error", result, 'error');
							});
						}
					}).then(response=>{
						if(response !== undefined){
							swal("Correcto", "Registro guardado correctamente.", 'success');
							
							this.props.history.push('/Shippings/report/envio/'+response.id);
						}
					})
				}else{
					swal('Error', 'Debe ingresar por lo menos una unidad', 'error');
				}
			}else{
				swal("¡Error!", "Campos Incompletos", 'error');
			}
		}else{
			notify.show('Error, Fecha no válida','error');
		}
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		if(input.id === 'requested_by' || input.id === 'requested_to'){
	    			isFormValid = this.getValidationState(input.id);
	    		}else{
	    			const isInputValid = this.showCtrlError(input.name);
			      	if (!isInputValid) {
			        	isFormValid = false;
			    	}
	    		}
	    		
			      			   
		  	}
	    });
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	isValidDate(fecha){
		var valid = moment(fecha).format('MM-DD-YYYY');

		if(valid === 'Invalid date'){
			return false;
		}else{
			return true;
		}
	}

	getValidationState(name) {
		const length = this.state[name].length;
		let isFormValid = true;
		if (length === 0){
			if(name==='requested_by'){
				this.setState({req_by:'error'});
				isFormValid = false;
			}else{
				this.setState({req_to:'error'});
				isFormValid = false;
			}
		}else{
			if(name==='requested_by'){
				this.setState({req_by:''});
			}else{
				this.setState({req_to:''});
			}
		}

		return isFormValid;

	}

	onCancel(){
		this.props.history.push("/shippings");
	}

	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');

		return(
			<div className="col-xs-12">
				<form noValidate>
					<div className="col-xs-12">
						<div className="col-xs-12">
							<div className="col-xs-12 col-sm-4">
								<FormGroup id="req_by" validationState={this.state.req_by || null} style={{marginBottom:"0px"}}>
									<span className="span-min">Centro Distribuidor</span>
									
									<AsyncTypeahead
							          	/*{...this.state}*/
							          	labelKey={(option) => `${option.name}`}
							          	minLength={0}
							          	inputProps={{
							          		name:"requested_by",
							          		required:true,
							          		id:"requested_by"
							          	}}
							          	id="requestedBy"
							          	disabled={true}
							          	options={this.state.health_facilities}
							          	onChange={this.handleTypeAheadChange('requested_by')}
							          	onSearch={this._handleSearch}
							          	defaultSelected={this.state.health_facilities.slice(this.state.indice, 1)}
							          	selected={this.state.requestedSelected}
							          	ref={ref => this._typeahead = ref}
							          	useCache={false}
							          	isLoading={this.state.isLoading}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
							    </FormGroup>
							</div>

							<div className="col-xs-12 col-sm-4">
								<FormGroup id="req_to" validationState={this.state.req_to || null} style={{marginBottom:"0px"}}>
									<div><span className="span-min">Hospital Solicitante</span></div>
									<div style={{width:this.state.user_add_center === 'YES' ? '90%' : '100%', display:'inline-block'}}>
										<AsyncTypeahead
											/*{...this.state}*/
											labelKey={(option) => `${option.name}`}
											minLength={0}
											inputProps={{
												name:"requested_to",
												required: true,
												id:"requested_to"
											}}
											id="requestedTo"
											options={this.state.national_centers}
											onChange={this.handleTypeAheadChange('requested_to')}
											onSearch={this._handleSearch2}
											defaultSelected={this.state.health_facilities.slice(this.state.indice2, 1)}
											selected={this.state.requested2Selected}
											ref={ref => this._typeahead = ref}
											useCache={false}
											isLoading={this.state.isLoading}
											delay={600}
											paginationText="Mostrar mas resultados..."
										/>
									</div>
									{this.state.user_add_center === 'YES' &&
										<div style={{width:'10%', display:'inline-block', textAlign:'center'}}>
											<FloatingActionButton className="action-btn" iconStyle={{height: 20, width: 20}} mini={true} 
												onClick={this.addCenter}  >
												<ContentAdd/>
											</FloatingActionButton> 
										</div>
									}
							    </FormGroup>
							</div>
							<div className="col-xs-12 col-sm-2" style={{padding:"0px"}}>
								<div className="col-xs-12 col-sm-6">
									<span className="span-min">Fecha Petición</span>
									<input className="form-control hour-input" name="date_form" id="date_form" type="date" 
										value={this.state.date_form || ""} onChange={this.handleChange} 
										ref={(input) => { this.inputRef = input }} disabled />
								</div>
								<div className="col-xs-12 col-sm-6">
									<span className="span-min">Hora Petición</span>
									<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" 
										data-inputmask-inputformat="HH:MM"  data-inputmask-placeholder="-" 
										value={this.state.hour || ""} onChange={this.handleChange}
										disabled className="form-control"/>
								</div>
							</div>

							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Prioridad</span>
								<select className="form-control" name="priority" id="priority" required
									onChange={this.handleChange} value={this.state.priority || ""} 
									onKeyPress={(e) => this.validateInput(e)}>
									<option value="">Seleccione...</option>
									{this.state.priorities.map((type, i) => (
										<option key={i} value={type.name}>{type.name}</option>
									))

									}
								</select>
							</div>
						</div>

						<div className="col-xs-12">
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Usuario Envía</span>
								<input className="form-control" disabled name="user" id="user" value={ this.state.user } onChange={ this.handleChange } required/>
							</div>

							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Mensajero</span>
								<input className="form-control" name="messenger" id="messenger" value={ this.state.messenger } 
									onKeyPress={(e) => this.validateInput(e)} onChange={ this.handleChange }/>
							</div>
							<div className="col-xs-12 col-sm-4">
								<span className="span-min">Resonsable en destino</span>
								<input className="form-control" name="responsable" id="responsable" 
									value={ this.state.responsable } onChange={ this.handleChange } required/>
							</div>
						</div>

						<div className="col-xs-12 form-group">

							<div className="col-xs-12 col-sm-8">
								<span className="span-min">Observaciones</span>
								<span style={{fontSize:'10px', marginLeft:'5px'}}>{'Caracteres restantes : '+this.state.character_observa}</span>
								<textarea className="form-control" name="observations" value={ this.state.observations } 
									style={{resize:"none"}} onChange={ this.handleChange } />
							</div>
							
						</div>

						<fieldset className="col-xs-8">
							<legend>Unidades</legend>

							<div className="col-xs-12 form-group">
								<div className="col-xs-12 col-sm-6">
									<span className="span-min">No. Unidad</span>
									<input type="text" name="unit_number" id="unit_number"  
											onChange={this.handleChange} value={this.state.unit_number || ""} 
											onKeyPress={(e) => this.searchComponent(e)}
											className={"form-control"} />
								</div>

								<div className="col-xs-12 col-sm-5">
									<span className="span-min">No. Componente</span>
									<Typeahead
							          	labelKey={(option) => `${option.label}`}
							          	minLength={0}
							          	inputProps={{
							          		name:"component",
							          		required:true,
							          		id:"component"
							          	}}
							          	id="component_text"
							          	selectHintOnEnter={true}
							          	onKeyDown={(e) => this.selectComponent(e, 'component')}
							          	options={this.state.component_list}
							          	onChange={this.handleTypeAheadChange('component')}
							          	onSearch={this._handleSearch}
							          	ref={ref => this._typeahead_component = ref}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
								</div>

								<div className="col-xs-12 col-sm-1">
									<FloatingActionButton className="action-btn" mini={true} style={{marginTop: 15 }} 
										onClick={this.addComponent}>
				                      <ContentAdd/>
				                    </FloatingActionButton> 
								</div>
							</div>

							<div className="col-xs-12">
								<label>Total de unidades:  </label>
								<span style={{marginLeft:'5px'}}>{'  '+this.state.unitsAdded.length}</span>
							</div>

							<div className="col-xs-12"> 
				              <Table responsive hover style={{margin:"0px"}}>
				                <thead>
				                  <tr>
				                    <th>No. Donación</th>
				                    <th>Componente Sanguíneo</th>
				                    <th>No. Componente</th>
				                    <th>Grupo & RH</th>
				                    <th>Volumen</th>
				                    <th></th>
				                  </tr>
				                </thead>
				                <tbody>
				                 {this.state.unitsAdded.map( (unit, index) => (
				                    <tr key={index}>
				                      <td>{unit.donation}</td>
				                      <td>{unit.component}</td>
				                      <td>{unit.component_number}</td>
				                      <td>{unit.group + (unit.rh === 'POSITIVO' ? '+' : '-')} </td>
				                      <td>{unit.volume}</td>
				                      <td width={60} style={{textAlign: "center",padding: "2px",}}>
				                        <Button className="btn btn-info btn-xs" title="Eliminar" style={{marginRight:'3px'}} 
				                        	onClick={(e) => this.removeUnitFromList(index, e)}>
				                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
				                        </Button>
				                      </td>
				                    </tr>
				                    ))}
				                </tbody>
				              </Table>
				            </div>
						</fieldset> 

						<hr style={{width:"100%"}}/>
						<div className="col-xs-12" style={{textAlign:'center'}}>
				        	<div>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave}  style={{margin:12}}
									disabled={this.state.save}/>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onCancel}/>
				        	</div>
				        </div>
					</div>
				</form>
				<Notifications />
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				
				<ModalCenter {...this.props} onRef={ref => (this.modal_add_center = ref)} 
					refresh={this.getNationalCenters} />
			</div>
		)
	}
}

export default translate('translations')(ShippingsNew);
